<template>
  <div class="flex flex-col font-rubik mt-12 max-[768px]:mt-8">
    <div class="m-0 p-0 flex justify-between gap-2 max-[768px]:gap-8 items-end flex-wrap">
      <ShareLinks :pagePath="articlePath" />
      <div class="flex gap-2">
        <Tag v-for="(tag, index) in tags" :key="index" :tag="tag" />
      </div>
    </div>
    <div class="w-full h-[1px] bg-[#EDE9E3] my-12 max-[768px]:my-8" />
    <div class="flex items-center gap-4">
      <img
        :src="authorProfilePhotoUrl || imagePlaceholder || '../../../images/placeholder.webp'"
        :alt="authorProfilePhotoAlt"
        class="rounded-full w-[3.5rem] h-[3.5rem] aspect-auto object-cover"
      />
      <div class="flex flex-col text-[1rem] leading-[1.5rem]">
        <span class="font-medium">{{ authorName || 'Unknown author' }}</span>
        <span class="font-normal">{{ authorDescription }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import ShareLinks from '../article-share-links/index.vue'
import Tag from '../tag/index.vue'

export default {
  components: {
    ShareLinks,
    Tag
  },
  props: {
    imagePlaceholder: {
      type: String,
      default: ''
    },
    authorName: {
      type: String,
      default: 'unknown author'
    },
    authorDescription: {
      type: String,
      default: ''
    },
    authorProfilePhotoUrl: {
      type: String,
      default: ''
    },
    authorProfilePhotoAlt: {
      type: String,
      default: 'author profile photo'
    },
    articlePath: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      default: () => []
    }
  }
}
</script>